import { API_URL } from '../../../../constants'

export const GET_TICKET = `${API_URL}/api/payout`
export const GET_LIST_TICKETS = `${API_URL}/api/payout/list`
export const GET_DETAIL_LIST_TICKETS = `${API_URL}/reports/tickets/payout/full`
export const GET_EMPLOYEE_LIST_TICKETS = `${API_URL}/api/internal/payout/list`
export const CHANGE_TICKET_CACHBOX = `${API_URL}/api/payout/change-cashbox`
